import {
	avatarSrc as absoluteAvatarSrc,
	createApiClient,
	uploadFile as clientUploadFile,
	type UploadParams,
	type UploadPath,
} from '@shared/api-client/index';
import { newMutationId } from '@shared/ui/realtime/mutation-tracker';

// The api origin (no version): each operation path carries its own /v1 prefix.
// The SSR serverApi (loaders) uses this same origin, forwarding the cookie.
export const apiOrigin = import.meta.env.VITE_API_URL ?? 'http://localhost:3000';

export const api = createApiClient(apiOrigin);

// Resolve a DTO `avatarUrl` to an absolute `<img>` src on this app's api origin.
export const avatarSrc = (avatarUrl: string | null | undefined) =>
	absoluteAvatarSrc(apiOrigin, avatarUrl);

// Tag every mutating request with a fresh id; the api echoes it back on the
// realtime event so the originating tab suppresses its own echo (it already
// applied the change optimistically). Registered on the client itself so it
// covers every mutation, not just routes that happen to import a given hook.
api.use({
	onRequest({ request }) {
		if (request.method !== 'GET' && request.method !== 'HEAD') {
			request.headers.set('x-kc-mutation-id', newMutationId());
		}
		return request;
	},
});

/** POST a single `file` as multipart/form-data, bound to this app's client. */
export function uploadFile<P extends UploadPath>(path: P, params: UploadParams<P>, file: File) {
	return clientUploadFile(api, path, params, file);
}
